import Skeleton from "react-loading-skeleton";

const SkeletonProjects = () => {
  return (
    <div className="h-[28rem] w-full rounded-[2rem] overflow-hidden">
      <Skeleton height="100%" width="100%" />
    </div>
  );
};

export default SkeletonProjects;
